






import { Component, Mixins } from "vue-property-decorator";
import { ContentMixin } from "./mixins";

@Component
export default class WizardContentFormatIndicator extends Mixins(ContentMixin) {
  get formatName(): string {
    return this.readPropertyOrDefault(s => s.attributes.format.name, "");
  }
}
